import { Directive, TemplateRef, Input } from '@angular/core';

@Directive({
  selector: '[appCustomTemplate]',
  standalone: true
})
export class CustomTemplateDirective {
  @Input() appCustomTemplateType: string;
  constructor(public templateRef: TemplateRef<any>) {}
}
